import { render, staticRenderFns } from "./tabs-view.vue?vue&type=template&id=e4bec32e&scoped=true"
import script from "./tabs-view.vue?vue&type=script&lang=js"
export * from "./tabs-view.vue?vue&type=script&lang=js"
import style0 from "./tabs-view.vue?vue&type=style&index=0&id=e4bec32e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bec32e",
  null
  
)

export default component.exports